<script>
    import { user_data } from './stores.js';
    import{flow_steps} from './stores.js';
    import { onMount } from "svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    // import Listcomponent from './components/listcomponent.svelte';
    import Listcomponent from './components/listcomponent.svelte';
    export let listdata = [
        {s: true, t: "Lower my monthly payment", cbf:()=>{$flow_steps.current_flow = "drr"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1; $user_data.refigoal = "Lower my monthly payment";}},
        {s: false, t: "Take cash out to pay for other expenses", cbf:()=>{$flow_steps.current_flow = "drr"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1; $user_data.refigoal = "Take cash out to pay for other expenses";}},
        {s: false, t: "Pay off my existing mortgage sooner", cbf:()=>{$flow_steps.current_flow = "dbr"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1; $user_data.refigoal = "Pay off my existing mortgage sooner";}},
        {s: false, t: "Consolidate high-interest debts", cbf:()=>{$flow_steps.current_flow = "dgr"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1; $user_data.refigoal = "Consolidate high-interest debts";}},
        {s: false, t: "Other", cbf:()=>{$flow_steps.current_flow = "drr"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1; $user_data.refigoal = "Other";}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
show_icon_card={true}
>
    <Progresscomponent 
    title="Great! What's your refinancing goal?"
    override_urlcheck={true}
    show_next_button={false}
    >
    <Listcomponent
        bind:listdata={listdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>